import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { CoinTransaction } from '../../models/CoinTransaction';
import { getMyCoinTransactions } from '../../state/coin-transaction/coin-transaction.actions';
import { selectCoinTransactions } from '../../state/coin-transaction/coin-transaction.selector';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { PageHeaderComponent } from '../page-header/page-header.component';

@Component({
  selector: 'app-coin-transactions',
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    PageHeaderComponent
  ],
  templateUrl: './coin-transactions.component.html',
  styleUrl: './coin-transactions.component.css'
})
export class CoinTransactionsComponent implements OnInit {
  transactions$: Observable<CoinTransaction[]>;

  constructor(private store: Store, private router: Router) {
    this.transactions$ = this.store.select(selectCoinTransactions).pipe(
      map(transactions => transactions || [])
    );
  }

  ngOnInit(): void {
    this.store.dispatch(getMyCoinTransactions());
  }

  back(): void {
    this.router.navigate(['/']);
  }

  exportToCSV() {
    this.transactions$.subscribe(async transactions => {
      if (!transactions || transactions.length === 0) return;
      const header = ['Datum', 'Grund', 'Auftragsnummer', 'Coins', 'Gewährt von'];
      const rows = transactions.map(tx => [
        tx.createdDate ? new Date(tx.createdDate).toLocaleString() : '',
        tx.reason?.reasonText || '',
        tx.reflexOrderNo || '',
        tx.amount || '',
        tx.reason?.reasonText?.includes('Generiert') ? 'Niclen GmbH' : (tx.grantedBy ? `${tx.grantedBy.firstName} ${tx.grantedBy.lastName}` : '')
      ]);
      const csvContent = [header, ...rows]
        .map(e => e.map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))
        .join('\r\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      if ('showSaveFilePicker' in window) {
        // @ts-ignore
        const handle = await window.showSaveFilePicker({
          suggestedName: 'meine-coin-transaktionen.csv',
          types: [{ description: 'CSV file', accept: { 'text/csv': ['.csv'] } }]
        });
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
      } else {
        // Fallback for browsers that don't support the API
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'meine-coin-transaktionen.csv';
        link.click();
        URL.revokeObjectURL(link.href);
      }
    }).unsubscribe();
  }
}
